// program to validate the phone number i.e must start with zero
export function validatePhone(num) {
  // regex pattern for phone number
  const re = /^0\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/g;
  // check if the phone number is valid
  return num.match(re);
}
